import ApiBase from './ApiBase';
import axios from 'axios';
import { stringify } from '../components/forked/stringify';

/**
 * Administrative Report API
 */
class AdminReportApi extends ApiBase {
  /**
   * Download report file
   * @param {*} reportId id of the report
   * @param {*} format 'data_json' | 'excel'
   * @param {*} filters {
   *  investorIds: ['AINV', 'BINV', ...],
   *  fundIds: ['AAF', 'AMBF', ...],
   * }
   * @param filterLabels
   */
  async download(reportId, format, filters, filterLabels) {
    const notSupportedFilterCriteria =
      'The report contains filter criteria that is not supported. One of the filters used must contain only one value checked/selected.';
    const maximumOutput =
      "The report has reached it's maximum output. Please change your filter selection to get results.";

    const queryParameters = stringify(
      {
        id: reportId,
        format
      },
      {
        arrayFormat: 'comma'
      }
    );

    let payload = { filters };
    if (format === 'excel') {
      payload = {
        ...payload,
        filterLabels
      };
    }

    const request = {
      url: `${this.API_URL}/adminreport/execute?${queryParameters}`,
      headers: this.getHeaders(),
      method: 'POST',
      responseType: format === 'data_json' ? 'json' : 'blob',
      data: payload,
      validateStatus: function(status) {
        return (status >= 200 && status < 300) || status === 400;
      }
    };

    const response = await axios.request(request);

    //Exception during report execution
    if (format === 'data_json') {
      if (response.status === 400) {
        if (response.data.errorMessage === notSupportedFilterCriteria) {
          throw new Error('report_has_bad_criteria');
        } else if (response.data.errorMessage === maximumOutput) {
          throw new Error('report_has_more_data');
        }
        throw new Error(response.data.errorMessage);
      }
    } else {
      // We requested blob format, but got error as JSON, decode it from BLOB
      if (response.status === 400) {
        const errorText = await response.data.text();
        const error = JSON.parse(errorText);
        if (error.errorMessage === notSupportedFilterCriteria) {
          throw new Error('report_has_bad_criteria');
        } else if (error.errorMessage === maximumOutput) {
          throw new Error('report_has_more_data');
        }
        throw new Error(error.errorMessage);
      }
    }

    return response;
  }
}

export default new AdminReportApi();
